/* eslint-disable tailwindcss/no-custom-classname -- Using dynamic values */
/* eslint-disable tailwindcss/classnames-order -- Using dynamic values */
import {PrismicNextImage} from '@prismicio/next/pages'
import {PrismicRichText} from '@prismicio/react'
import type {AffiliatesBannerSliceDefaultPrimaryAffiliateBlockItem} from 'prismicio-types'
import {Fragment} from 'react'
import {CELL_COMMON_CLASSES} from 'slices/AffiliatesBanner/constants'

export const AffiliateBlock = ({
  block,
  colStart,
}: {
  block: AffiliatesBannerSliceDefaultPrimaryAffiliateBlockItem
  colStart: number
}) => (
  <Fragment>
    <div className={`${CELL_COMMON_CLASSES} row-start-1 ml-[-1px] rounded-t-none border-t-0 col-start-${colStart}`} />
    <div
      className={`${CELL_COMMON_CLASSES} col-span-1 row-start-2 ml-[-1px] mt-[-1px] flex items-center justify-center bg-moss-white col-start-${colStart}`}
    >
      <PrismicNextImage field={block.logo} className="h-[18px] w-auto" />
    </div>
    <div
      className={`${CELL_COMMON_CLASSES} col-span-1 row-start-3 ml-[-1px] mt-[-1px] flex flex-col items-center justify-center gap-1 px-4 py-5 md:py-4 col-start-${colStart}`}
    >
      <PrismicRichText
        field={block.text}
        components={{
          heading6: ({children}) => <p className="text-tg-body-m text-moss-black font-normal">{children}</p>,
          paragraph: ({children}) => (
            <p className="text-black-60 text-button-s leading-[14px] md:text-tg-body-s md:font-medium">{children}</p>
          ),
        }}
      />
    </div>
  </Fragment>
)
